import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPlanIconSecondary from './svgs/PlanIconSecondary.js';
import SvgPlanIcon from './svgs/PlanIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var planIcon = (props => useIcon(SvgPlanIcon, SvgPlanIconSecondary, props));

export { planIcon as default };
